import { useState } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import H4 from '@base/H4/H4';
import H5 from '@base/H5/H5';
import P1 from '@base/P1/P1';
import ChevronRight from '@icon/ChevronRight';
import { Spacings, mediaQuery } from '@styles/index';
import Accordion from '@base/Accordion/Accordion';

const Wrapper = styled.div`
  grid-column: span 24;
  display: grid;
  grid-template-columns: repeat(24, ${Spacings.SPACING_8B});
  grid-column-gap: ${Spacings.SPACING_4B};
  margin-top: ${Spacings.SPACING_12B};
  ${mediaQuery.uptoMobile} {
    grid-column: span 10;
    grid-template-columns: repeat(10, 1fr);
    grid-column-gap: ${Spacings.SPACING_2B};
    margin-top: ${Spacings.SPACING_0B};
    margin-bottom: ${Spacings.SPACING_10B};
  }
`;

const TitleWrapper = styled(H4)`
  grid-column: 2/8;
  position: sticky;
  top: 235px;
  z-index: 1;
  ${mediaQuery.uptoMobile} {
    top: ${Spacings.SPACING_12B};
    padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_0B};
    padding-top: ${Spacings.SPACING_0B};
    grid-column: span 10;
    margin-bottom: ${Spacings.SPACING_2B};
  }
`;

const InnerWrapper = styled.div`
  grid-column: 9/25;
  display: grid;
  z-index: 1;
  ${mediaQuery.uptoMobile} {
    grid-column: span 10;
  }
`;

const StyledAccordion = styled(Accordion)`
  &.MuiAccordion-root {
    padding: ${Spacings.SPACING_4B} !important;
    margin: 0px !important;
    margin-bottom: ${Spacings.SPACING_4B} !important;
  }
  .goal-card-container {
    padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_0B};
    margin: ${Spacings.SPACING_1B} ${Spacings.SPACING_0B};
    box-shadow: none;
  }
`;

const StyledAccordionSummary = styled(Accordion.Summary)`
  &.MuiAccordionSummary-root {
    min-height: 0px;
  }
  .MuiAccordionSummary-content {
    display: flex !important;
    align-items: center !important;
  }
`;

const FaqQuestion = styled(H5)`
  margin-right: ${Spacings.SPACING_4B};
`;

const StyleAccordionDetails = styled(Accordion.Details)`
  margin-top: ${Spacings.SPACING_4B};
`;

const StyledChevron = styled(ChevronRight)`
  transform: ${({ $expanded }) =>
    $expanded ? 'rotate(-90deg)' : 'rotate(-270deg)'};
  transition: transform 150ms ease;
  margin-left: auto;
  flex-shrink: 0;
`;

const BatchFaqs = ({ faqs }) => {
  if (!faqs?.length) return null;
  return (
    <Wrapper>
      <TitleWrapper>Frequently asked questions</TitleWrapper>
      <InnerWrapper>
        <FAQList faqs={faqs} />
      </InnerWrapper>
    </Wrapper>
  );
};

export default BatchFaqs;

BatchFaqs.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired
};

export const FAQList = ({ faqs }) => {
  const [expandedIndex, setExpandedIndex] = useState(-1);
  if (!faqs?.length) return null;

  const handleAccordionClick = (index) => {
    setExpandedIndex(expandedIndex === index ? -1 : index);
  };
  return (
    <>
      {faqs.map((faq, index) => (
        <StyledAccordion
          key={faq.id}
          expanded={expandedIndex === index}
          onClick={() => handleAccordionClick(index)}
        >
          <StyledAccordionSummary>
            <FaqQuestion>{faq.question}</FaqQuestion>
            <StyledChevron
              color="var(--color-text-primary)"
              size="24px"
              $expanded={expandedIndex === index}
            />
          </StyledAccordionSummary>
          <StyleAccordionDetails>
            <P1>{faq.answer}</P1>
          </StyleAccordionDetails>
        </StyledAccordion>
      ))}
    </>
  );
};
